import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupChamados(): void {
  applicationModuleRegistry.register({
    entry: 'chamados',
    id: 'chamados',
    name: 'beneficiary.calls',
    route: Routes.CHAMADOS,
    order: 5,
    closeable: true,
  });
}
